import {
  getDiscordClientIdFromEnv,
  getFrontendEndpoint,
} from "../../config/env";

export const DISCORD_REDIRECT_URL = `https://discord.com/api/oauth2/authorize?client_id=${getDiscordClientIdFromEnv()}&redirect_uri=${getFrontendEndpoint()}/oauth2/discord_callback/&response_type=code&scope=guilds%20identify`;

export enum DiscordAuthMessage {
  Success = "DISCORD_AUTH_SUCCESS",
  Error = "DISCORD_AUTH_ERROR",
}

export const formattedDiscordMessage = (
  type: DiscordAuthMessage,
  message: string,
): string => {
  return message.substring(type.length, message.length);
};

export const openDiscordAuthWindow = () => {
  if (!window) {
    return;
  }

  window.open(
    DISCORD_REDIRECT_URL,
    "discord",
    "menubar=1,resizable=1,scrollbars=1,width=900,height=800",
  );
};
